import { render, staticRenderFns } from "./FuButton.vue?vue&type=template&id=3e54c125&"
import script from "./FuButton.vue?vue&type=script&lang=js&"
export * from "./FuButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports